import { TCText } from "../../../components/TCText/TCText";
import { Colors } from "../../../utils/colors";
import { TOTAL_SCORE_SETS } from "../../../utils/constants";

export const ScoreSetHeader = () => {
  const getSetValue = (index: number) => {
    switch (index) {
      case 0:
        return "|";
      case 1:
        return "||";
      case 2:
        return "|||";
      default:
        return "";
    }
  };
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginTop: 10,
        marginBottom: 10,
      }}>
      <TCText
        value="Game score per set"
        style={{
          fontSize: 12,
          fontWeight: 600,
          color: Colors.grey,
          flex: 1,
        }}
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flex: 1,
        }}>
        {Array.from({ length: TOTAL_SCORE_SETS }).map((_, index) => (
          <TCText
            key={index}
            value={getSetValue(index)}
            style={{
              fontSize: 12,
              fontWeight: 600,
              color: Colors.grey,
              flex: 1,
              textAlign: "center",
            }}
          />
        ))}
        <TCText
          value={""}
          style={{
            flex: 1,
          }}
        />
      </div>
    </div>
  );
};
